module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/playerQuotes/jamal_green-6727c9e3d2f416550c8546b903259d05.svg";